import React from 'react';
import { useDispatch } from 'react-redux';
import { StructureGrayButton } from '../../../../MyTeamBackofficeStyled';
import { getBottomTeamMember } from '../../../../myTeamBackOffice.actions';

export const GoBottomButton = ({
  label,
  position,
  isDisabled,
  structureType
}) => {
  const dispatch = useDispatch();
  const goBottom = () => {
    if (isDisabled) return;
    console.log(structureType);
    dispatch(getBottomTeamMember(position, structureType));
  };

  return (
    <StructureGrayButton disabled={isDisabled} onClick={goBottom}>
      {label}
    </StructureGrayButton>
  );
};
